<template>
  <div class="userMain">
    <!-- 搜索框 -->
    <SearchBar
      ref="searchBar"
      @search="search"
      @openAddAuth="openAddAuth"
      :rolesList="rolesList"
      :checkList="checkList"
      :isInternal="1"
    />

    <!-- 表单 -->
    <el-table
      v-loading="listLoading"
      :data="list"
      element-loading-text="Loading"
      border
      @selection-change="handleSelectionChange"
      fit
      highlight-current-row
      height="660"
    >
      <el-table-column type="selection" width="55"> </el-table-column>
      <el-table-column align="center" width="60" label="编号">
        <template slot-scope="scope">
          {{ pageSize * (pageIndex - 1) + (scope.$index + 1) }}
        </template>
      </el-table-column>

      <!-- <el-table-column label="工号" align="center">
        <template slot-scope="scope">
          {{ scope.row.userCode }}
        </template>
      </el-table-column> -->

      <el-table-column label="用户名" align="center">
        <template slot-scope="scope">
          {{ handledecrypt(scope.row.nickName) }}
        </template>
      </el-table-column>

      <el-table-column label="所属公司" align="center">
        <template slot-scope="scope">
          {{ scope.row.company || '无' }}
        </template>
      </el-table-column>

      <el-table-column label="账号" align="center">
        <template slot-scope="scope">
          <span>{{ handledecrypt(scope.row.mobile) }}</span>
        </template>
      </el-table-column>

      <el-table-column label="角色" align="center">
        <template slot-scope="scope">
          <el-select
            v-model="scope.row.role.roleName"
            placeholder="请选择"
            @change="changeRole"
            @focus="getRoleId(scope.row.userId)"
            :disabled="!roleList[path].includes('_Edit_role')"
          >
            <el-option
              v-for="item in rolesList"
              :key="item.roleId"
              :label="item.roleName"
              :id="item.roleId"
              :value="item.roleId"
            >
            </el-option>
          </el-select>
        </template>
      </el-table-column>

      <el-table-column class-name="status-col" label="状态" align="center">
        <template slot-scope="scope">
          <el-switch
            v-model="scope.row.status"
            :disabled="!roleList[path].includes('_Change_Status')"
            @change="changeStatus(scope.row.status, scope.row)"
            inactive-color="#ff4949"
            active-color="#13ce66"
          >
          </el-switch>

          <!-- <el-select  v-model="statusList[scope.row.status]" placeholder="请选择" @change="changeStatus"  @focus="getRoleId(scope.row.userId)">
          <el-option
            v-for="item in statusList"
            :key="item.id"
            :label="item.value"
            :id="item.id"
            :value="item.id">
          </el-option>
        </el-select> -->
        </template>
      </el-table-column>

      <el-table-column class-name="status-col" label="登录时间" align="center">
        <template slot-scope="scope" v-if="scope.row.loginTime">
          <div>{{ scope.row.loginTime }}</div>
        </template>
      </el-table-column>

      <el-table-column class-name="status-col" label="创建时间" align="center">
        <template slot-scope="scope" v-if="scope.row.creationTime">
          <div>{{ scope.row.creationTime }}</div>
        </template>
      </el-table-column>

      <!-- <el-table-column class-name="status-col" label="修改时间" align="center">
        <template slot-scope="scope"  v-if="scope.row.updationTime">
          <div >{{ scope.row.updationTime  }}</div>
        </template>
    </el-table-column> -->

      <el-table-column class-name="status-col" label="操作" align="center">
        <template slot-scope="scope">
          <el-button
            size="small"
            icon="el-icon-edit"
            @click="handleEdit(scope.row)"
            style="margin: 0 0 10px"
            >编辑账号</el-button
          >
          <el-button
            size="small"
            @click="handleResetPasswords(scope.row)"
            type="info"
            v-if="roleList[path].includes('_UpdatePwd')"
            >重置密码</el-button
          >
        </template>
      </el-table-column>
    </el-table>

    <!-- 分页 -->
    <Pagination ref="Pagination" />

    <!-- 添加表单对话框 -->
    <addAuth ref="addAuth" @search="search" />

    <!-- 重置密码 -->
    <ResetPasswords ref="resetPasswords"></ResetPasswords>
  </div>
</template>

<script>
import {
  getUserModelApi,
  stopUserApi,
  startUserApi,
  getRoleListApi,
  setRoleApi,
} from '@/api/user.js';
const addAuth = () => import('../components/addAuth'); // 增加表单
import Pagination from '@/components/Pagination'; // 分页
import SearchBar from '../components/searchBar'; // 搜索框
import ResetPasswords from '../components/resetPasswords';
import { mapGetters } from 'vuex';
import { decrypt } from '@/utils/encryp';
export default {
  components: {
    addAuth,
    Pagination,
    SearchBar,
    ResetPasswords,
  },
  data() {
    return {
      list: null,
      rolesList: [],
      statusList: [
        { id: 1, value: '启用' },
        { id: 2, value: '禁用' },
      ],
      listLoading: false,
      // size和index用于计算编号
      pageSize: 20,
      pageIndex: 1,
      path: '',
      checkList: [],
    };
  },
  created() {
    this.getAllRoles();
    this.fetchData();
    const array = this.$route.path.split('/');
    this.path = array[array.length - 1];
    // console.log('path', this.path);
    // console.log('roleList', this.roleList);
  },
  mounted() {
    document.querySelector('.el-table__body-wrapper').style.height = '580px';
  },

  computed: {
    ...mapGetters(['paginObj', 'roleList']),
  },

  watch: {
    // 当分页组件中页码或页容量发生改变时会重新发请求渲染页面
    paginObj: 'fetchData',
  },
  methods: {
    // 处理解密
    handledecrypt(str) {
      if (!str) return;
      return decrypt(str);
    },
    // 请求表单数据
    // searchBar会触发此方法
    async fetchData() {
      try {
        this.listLoading = true;
        // 内部账号不需要areaId 过滤 禅道bug ID 4184 有备注
        const areaId = localStorage.getItem('areaId')
          ? JSON.parse(localStorage.getItem('areaId')).areaId
          : '';
        let res = await getUserModelApi({
          pageSize: this.paginObj.pageSize,
          pageIndex: this.paginObj.pageIndex,
          isInternal: 1,
          ...this.fromSearchObj,
          areaId,
        });
        let { pageSize, pageIndex, dataList, totalCount } = res.data;

        // console.log('列表：', dataList);
        // 深拷贝一份，避免status都转换为false,转换后把0改成true，1改成false
        // 0为启用， 1为禁用
        let newData = dataList ? JSON.parse(JSON.stringify(dataList)) : [];

        newData.forEach((item) => {
          item.status = item.status === 0 ? true : false;
        });
        this.list = newData;
        this.listLoading = false;
        this.pageSize = pageSize;
        this.pageIndex = pageIndex;
        this.$refs.Pagination.pageSize = pageSize;
        this.$refs.Pagination.pageIndex = pageIndex;
        this.$refs.Pagination.totalCount = totalCount;
      } catch (e) {
        window.console.log(e);
      }
    },

    // 搜索
    search(obj = {}) {
      if (obj) this.fromSearchObj = obj;
      // 重置页码
      this.$store.dispatch('area/setPaginObj', {
        pageIndex: 1,
        pageSize: 20,
      });
    },
    handleSelectionChange(val) {
      this.checkList = val.map((item) => {
        return item.userId;
      });
    },
    // 查看系统所有角色
    async getAllRoles() {
      let res = await getRoleListApi();
      this.rolesList = res.data;
      this.$refs.searchBar.rolesList = this.rolesList.concat({
        roleName: '全部',
        roleId: '',
      });
    },

    // 变更状态
    async changeStatus(val, row) {
      this.listLoading = true;
      // 0为启用， 1为禁用
      try {
        let res =
          val === true
            ? await startUserApi(row.userId)
            : await stopUserApi(row.userId);
        this.listLoading = false;
        if (res.code !== 200) return;
        val === true
          ? this.$message.success('启用成功!')
          : this.$message.success('禁用成功!');
      } catch (e) {
        window.console.log(e);
      }
    },

    // 修改角色
    async changeRole(val) {
      try {
        let res = await setRoleApi(val, this.userId);
        if (res.code !== 200) return;
        this.$message.success('更换成功！');
      } catch (e) {
        window.console.log(e);
        this.$message.error(e.message);
      }
    },

    // 重置密码
    handleResetPasswords(row) {
      // console.log('userid', row);
      this.$refs.resetPasswords.editForm.userId = row.userId;
      this.$refs.resetPasswords.dialogFormVisible = true;
    },

    // 角色下拉框获取焦点时,获取当前行用户id
    getRoleId(id) {
      this.userId = id;
    },

    // 编辑用户
    handleEdit(row) {
      let { nickName, mobile, password, roleId, userId, userType } = row;
      // console.log('编辑用户：', nickName, mobile, password);
      this.$refs.addAuth.rolesList = this.rolesList;
      this.$refs.addAuth.title = '编辑账号';
      this.$refs.addAuth.addForm = {
        nickName: decrypt(nickName.replace(/\(.*\)/, '')),
        mobile: decrypt(mobile),
        password: decrypt(password),
        roleId,
        userId,
        userType,
      };
      // console.log(row);
      this.$refs.addAuth.dialogFormVisible = true;
    },

    // 打开增加表单
    openAddAuth(val) {
      this.$refs.addAuth.dialogFormVisible = val;
      this.$refs.addAuth.title = '新增账号';
      this.$refs.addAuth.addForm = {
        nickName: '',
        mobile: '',
        password: '',
        roleId: '',
      };
      this.$refs.addAuth.rolesList = this.rolesList;
    },
  },
};
</script>

<style lang="less" scoped>
.userMain {
  // width: 100vw;
  // height: 100vh;
  display: flex;
  flex-direction: column;
  justify-content: space-around;
}

.table {
  height: 75vh;
  overflow: auto;
  // white-space: nowrap;
  // overflow-x: scroll;
}

/deep/ .el-checkbox__input {
  margin-left: 10px;
}

// 隐藏选择框的文字
/deep/ .el-checkbox__label {
  display: none;
}
/deep/ .el-table__body-wrapper {
  height: 660px !important;
}
.btn {
  margin-bottom: 10px;
}
</style>
